import {RowFillDown} from 'notebook/tables/store/logic/RowFillDownLogic';

export {isCellSelected} from 'notebook/tables/core-ui/TableRowUtils';

export function cellFillProps(
  rowModel: RowFillDown,
  j: number
): {
  isFillDownBoxLeftEdge: boolean;
  isFillDownBoxRightEdge: boolean;
  isFillDownBoxTopEdge: boolean;
  isFillDownBoxBottomEdge: boolean;
} {
  return {
    isFillDownBoxLeftEdge:
      rowModel.isFilledDown && (rowModel.fillMinJ === j || j === (rowModel.fillMaxJ || 0) + 1),
    isFillDownBoxRightEdge:
      rowModel.isFilledDown && (rowModel.fillMaxJ === j || j === (rowModel.fillMinJ || 0) - 1),
    isFillDownBoxTopEdge:
      rowModel.isFillDownBoxTopEdge && (rowModel.fillMinJ || 0) <= j && j <= (rowModel.fillMaxJ || 0),
    isFillDownBoxBottomEdge:
      rowModel.isFillDownBoxBottomEdge && (rowModel.fillMinJ || 0) <= j && j <= (rowModel.fillMaxJ || 0),
  };
}
